
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_30412","data-name":"Group 30412","transform":"translate(-450.408 -109.408)"}},[_c('circle',{attrs:{"id":"Ellipse_181","data-name":"Ellipse 181","cx":"6","cy":"6","r":"6","transform":"translate(450.408 109.408)","fill":"#fff"}}),_c('g',{attrs:{"id":"Group_28025","data-name":"Group 28025","transform":"translate(-351.592 -179.936)","fill":"#5f8ff1"}},[_c('circle',{attrs:{"id":"Ellipse_356","data-name":"Ellipse 356","cx":"1","cy":"1","r":"1","transform":"translate(807 297.5)"}}),_c('path',{attrs:{"id":"Path_20099","data-name":"Path 20099","d":"M681.343 388.182a.9.9 0 00-1.27-1.27l-2.346 2.346a.9.9 0 001.27 1.27z","transform":"rotate(-45 629.758 186.43)"}})])])])
          )
        }
      }
    